interface RefractionData {
  od_sphere_far: string;
  od_cylinder_far: string;
  od_axis_far: string;
  od_add_far: string;
  od_prisma_far: string;
  od_sphere_near: string;
  od_cylinder_near: string;
  od_axis_near: string;
  od_add_near: string;
  od_prisma_near: string;
  oi_sphere_far: string;
  oi_cylinder_far: string;
  oi_axis_far: string;
  oi_add_far: string;
  oi_prisma_far: string;
  oi_sphere_near: string;
  oi_cylinder_near: string;
  oi_axis_near: string;
  oi_add_near: string;
  oi_prisma_near: string;
}

interface RefractionGridProps {
  data: RefractionData;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

export const RefractionGrid = ({ data, onChange, disabled = false }: RefractionGridProps) => {
  const inputClass = "w-full rounded-lg border border-slate-200 bg-[#f6f7f8] p-3 text-center text-sm sm:text-lg text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-colors";

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-center">
        <thead className="border-b border-slate-200">
          <tr>
            <th className="p-3 font-medium text-slate-500 w-24"></th>
            <th className="p-3 font-medium text-slate-500">Esfera</th>
            <th className="p-3 font-medium text-slate-500">Cilindro</th>
            <th className="p-3 font-medium text-slate-500">Eje</th>
            <th className="p-3 font-medium text-slate-500">Adición</th>
            <th className="p-3 font-medium text-slate-500">Prisma</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="p-2 font-bold text-slate-600">Lejos OD</td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="od_sphere_far"
                value={data.od_sphere_far}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="od_cylinder_far"
                value={data.od_cylinder_far}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="od_axis_far"
                value={data.od_axis_far}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="od_add_far"
                value={data.od_add_far}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="od_prisma_far"
                value={data.od_prisma_far}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
          </tr>
          <tr>
            <td className="p-2 font-bold text-slate-600">Lejos OI</td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="oi_sphere_far"
                value={data.oi_sphere_far}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="oi_cylinder_far"
                value={data.oi_cylinder_far}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="oi_axis_far"
                value={data.oi_axis_far}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="oi_add_far"
                value={data.oi_add_far}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="oi_prisma_far"
                value={data.oi_prisma_far}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
          </tr>
          <tr>
            <td className="p-2 font-bold text-slate-600">Cerca OD</td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="od_sphere_near"
                value={data.od_sphere_near}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="od_cylinder_near"
                value={data.od_cylinder_near}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="od_axis_near"
                value={data.od_axis_near}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="od_add_near"
                value={data.od_add_near}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="od_prisma_near"
                value={data.od_prisma_near}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
          </tr>
          <tr>
            <td className="p-2 font-bold text-slate-600">Cerca OI</td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="oi_sphere_near"
                value={data.oi_sphere_near}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="oi_cylinder_near"
                value={data.oi_cylinder_near}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="oi_axis_near"
                value={data.oi_axis_near}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="oi_add_near"
                value={data.oi_add_near}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
            <td className="p-2">
              <input 
                className={inputClass}
                type="text"
                name="oi_prisma_near"
                value={data.oi_prisma_near}
                onChange={onChange}
                disabled={disabled}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
